module.exports = __webpack_public_path__ + "img/HS0006.8d7224f.webp";